const Utils = {
  changeLanguage(e) {
    e.preventDefault();
    const langCode = e.target.getAttribute("data-language-code");
    const d = new Date();
    d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `language=${langCode};${expires};path=/`;

    return langCode;
  },
  getLanguageCookie() {
    if (this.getUrlVar("language")) {
      return this.getUrlVar("language");
    }
    if (this.getCookie("language")) {
      return this.getCookie("language");
    }
  },
  // Make case-insensitive by default to accept
  // all query params.
  getUrlVar(key, caseSensitive = false) {
    const vars = {};
    window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function getVars(m, k, value) {
        if (!caseSensitive) {
          k = k.toLowerCase();
        }
        vars[k] = value;
      }
    );
    if (!caseSensitive) {
      key = key.toLowerCase();
    }

    return vars[key] === undefined ? "" : vars[key];
  },
  getCookie(cname) {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },
  objectIsEmpty(map) {
    for (const key in map) { // eslint-disable-line
      if (map.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  },
  emailRegex() {
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  },
  isValidEmailDomain(domainArray, enteredEmail) {
    const getEmailDomain = enteredEmail
      .toLowerCase()
      .substring(enteredEmail.lastIndexOf("@") + 1);
    const emailDomainExists = getEmailDomain.length > 0;
    const domainMatch = domainArray.indexOf(getEmailDomain) !== -1;
    if (emailDomainExists && domainMatch) {
      return true;
    }
    return false;
  },
  // Should be kept in-sync with
  // \Drupal\telus_entity\TelusConstants::REGEX_NAME_PART.
  nameRegex() {
    return /^[a-zàâéêèìôùûç ,.\\'-]{2,}$/i;
  },
  businessNameRegex() {
    return /^[-a-z0-9àâçéèêëîïôûùüÿñæœ .@#!$%^&*()+|~=`{}[\]:";'<>?,/\\]*$/i;
  },
};

export default Utils;
